const initTimelineHistory = () => {
	const historyPage = document.querySelector( 'body.history_page' );

	if ( !historyPage )
	{
		return;
	}

	const firstTitle = historyPage.querySelector( 'section.text.without-title > div.markup.without-title > h3' );

	if ( !firstTitle )
	{
		return;
	}

	firstTitle.classList.add( 'firts' );

	let div = document.createElement( 'div' );
	div.className = 'line';
	div.style.height = `calc( 100% - ${firstTitle.offsetTop - 40}px )`;
	
	firstTitle.append( div );

	window.addEventListener( 'resize', () => {
		div.style.height = `calc( 100% - ${firstTitle.offsetTop - 40}px )`;
	} );
};

export {
	initTimelineHistory,
}
